export default __webpack_public_path__ + "static/media/bgImg.e89dcdd0.png";